<template>
  <div class="contact-support-options-dialog-container" v-if="showContactSupportOptions">
    <wxc-overlay :left="left" :show="true" :hasAnimation="false"></wxc-overlay>
    <div class="dialog-box" :style="{top:top+'px', left: ((isWeb ? left : 0) + 20) + 'px', right: ((isWeb ? right : 0) + 20) + 'px'}">
      <div class="dialog-content">

        <weex-image
          class="dialog-cross-image"
          @click="crossClicked"
          :src="crossImage">
        </weex-image>

        <div class="dialog-content-below-cross"></div>

        <wxc-button
          text="Email us"
          size="medium"
          type="green"
          class="horizontal_center margin_top_20"
          @wxcButtonClicked="onContactSupportAction('email')">
        </wxc-button>

        <wxc-button
          :text="callUsText"
          size="medium"
          type="green"
          class="horizontal_center margin-top-30"
          @wxcButtonClicked="onContactSupportAction('call')">
        </wxc-button>

        <wxc-button
          v-if="false"
          text="Chat with us"
          size="medium"
          type="green"
          class="horizontal_center margin-top-30"
          @wxcButtonClicked="onContactSupportAction('chat')">
        </wxc-button>
      </div>
    </div>
  </div>
</template>

<script>
import WxcButton from '@/../weex-ui/packages/wxc-button/index'
import WxcOverlay from '@/../weex-ui/packages/wxc-overlay/index'
import env from '@/utils/env'
import { ImageResourcesUtil } from '@/utils/ImageResourcesUtil'
import { environment } from "@/environments/environment";

export default {
  components: { WxcOverlay, WxcButton },
  props: {
    showContactSupportOptions: {
      type: Boolean,
      required: true,
      default: false
    },

    top: {
      type: Number,
      default: 150
    },

    left: {
      type: Number,
      default: 0
    },
    right: {
      type: Number,
      default: 0
    }
  },
  data: () => ({}),

  methods: {
    onContactSupportAction (action) {
      this.$emit('onContactSupportAction', action)
    },

    crossClicked () {
      this.$emit('onDialogClose', {})
    },
  },

  computed: {
    crossImage () {
      return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CANCEL_RED)
    },

    isWeb () {
      return env.isWebPlatform()
    },

    callUsText() {
      return 'Call : ' + environment.contactSupportMobile
    }
  }
}
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
.contact-support-options-dialog-container {
  position: fixed;
  z-index: 9999;
}

</style>
